import AimDialog from "./aim-dialog";
export default AimDialog;
